import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Container } from "reactstrap";
import "./organization.css";
import OrganizationInfoForm from "../../components/organization-info";
import {
  organizationInfoSelector,
  loadingSelector,
  loadingSelectorUpdate,
} from "../../selectors";

import { getOrganizationInfo, updateOrganizationInfo } from "../../actions";
import PageTitle from "../../../../components/common/PageTitle";
import FullscreenLoader from "../../../../layouts/FullScreenLoader";

const OrganizationPage = () => {
  const organizationInfo = useSelector(organizationInfoSelector);
  const loading = useSelector(loadingSelector);
  const loadingUpdate = useSelector(loadingSelectorUpdate);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getOrganizationInfo());
  }, []);

  const handleSubmit = (data) => {
    dispatch(updateOrganizationInfo(data));
  };

  return (
    <React.Fragment>
      <PageTitle title="periodicity settings" className="bg-white" />{" "}
      <FullscreenLoader loading={loading || loadingUpdate} />
      <Container
        style={{ opacity: loading || loadingUpdate ? 0 : 1 }}
        className="client-profile-entries-page-container col-12 p-0"
        tabIndex="0"
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            document
              .getElementById("searchClientProfileEntriesSubmitButton")
              .click();
          }
        }}
      >
        <OrganizationInfoForm
          handleSubmit={handleSubmit}
          organizationInfo={organizationInfo}
        />
      </Container>
    </React.Fragment>
  );
};

export default OrganizationPage;



// WEBPACK FOOTER //
// ./src/features/organization/pages/settings/organization.jsx